import type { MusinsaStandardResponse } from '@musinsa/packages-http';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { z } from 'zod';

import { publicHttpClient } from '../httpClient';
import { joinApiPath } from './apiPath';

const SnsAccountSchema = z.object({
  snsType: z.enum(['ETC', 'INSTAGRAM', 'YOUTUBE', 'TWITTER', 'TIKTOK']),
  url: z.string().url(),
});

const SubmitApplicationRequestSchema = z.object({
  snsAccounts: z.array(SnsAccountSchema).min(1),
  shopTitle: z
    .string()
    .min(1)
    .regex(/^[a-zA-Z0-9]+$/, '큐레이션 샵 타이틀은 영문과 숫자만 사용 가능합니다'),
  agreedTerms: z
    .array(
      z.enum([
        'SERVICE_TERMS',
        'SERVICE_POLICY',
        'SERVICE_TERMS_V1',
        'SERVICE_TERMS_V2',
        'SERVICE_POLICY_V1',
        'PRIVACY_COLLECTION_V1',
      ]),
    )
    .min(1),
});

export type SubmitApplicationRequest = z.infer<typeof SubmitApplicationRequestSchema>;

const SubmitApplicationResponseSchema = z.object({
  curatorId: z.string(),
});

export type SubmitApplicationResponse = MusinsaStandardResponse<
  z.infer<typeof SubmitApplicationResponseSchema>
>;

export const submitApplication = (params: SubmitApplicationRequest) =>
  executeStandardRequest(() =>
    publicHttpClient.post<SubmitApplicationResponse>(
      urlJoin(joinApiPath.submitApplication),
      params,
    ),
  );
